<template>
  <div class="p-8 h-full ml-4 mr-4">
    <h1>Meteorologia</h1>
    <!-- <h6 class="mb-4">Explore os Gráficos de Satélite: Controle sua Visualização e Acompanhe as Mudanças Ambientais em Tempo Real!</h6> -->
    <div class="alert alert-info alert-dismissible fade show" role="alert">
      <strong>Personalize sua Análise Meteorológica: </strong>
      Opte por visualizar dados observados ou previstos e selecione a frequência desejada, seja diária ou mensal. Além
      disso, escolha entre diferentes fontes de informação, como CFS/GFS, ECMWF, Comparativo ou Meteum, para obter os
      insights meteorológicos mais relevantes para você.
      <feather-icon class="cursor-pointer close-button-alert" icon="XIcon" size="16" id="button-close" />

    </div>
    <section class="alert m-0 p-0">
      <div class="row row-labels">
        <label class="col-md-3">Análise</label>
        <label class="col-md-3">Período</label>
        <label class="col-md-6">Tipo de Relatório
          <feather-icon class="cursor-pointer" icon="InfoIcon" size="16" id="report-type-info-popover-target" />
        </label>

        <b-popover target="report-type-info-popover-target" triggers="hover" placement="top">
          <template #title class="title-popover">Relatórios</template>
          <div>
            <b>CFS/GFS:</b>
            <span>
              CFS/GFS: Modelos dos EUA para previsão do clima (CFS) e tempo (GFS).
            </span>
          </div>
          <hr>
          <div>
            <b>ECMWF:</b>
            <span>
              ECMWF: Centro europeu líder em previsões meteorológicas de curto e médio prazo.
            </span>
          </div>
          <hr>
          <div>
            <b>Comparativo:</b>
            <span>
              CFS/GFS (EUA) vs. ECMWF (Europa): Modelos líderes em previsão meteorológica global.
            </span>
          </div>
          <hr>
          <div>
            <b>Meteum:</b>
            <span>
              Plataforma de previsão meteorológica personalizada.
            </span>
          </div>
        </b-popover>

      </div>
      <div class="row mb-0">
        <section class="col-md-3">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">Observado</b-button>
            <b-button>Previsto</b-button>
          </b-button-group>
        </section>
        <section class="col-md-3">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">Diário</b-button>
            <b-button>Mensal</b-button>
          </b-button-group>
        </section>
        <section class="col-md-6">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn">CFS/GFS</b-button>
            <!-- <b-button class="btn btn-selected">CFS/GFS</b-button> -->
            <b-button>ECMWF</b-button>
            <b-button>Comparativo</b-button>
            <b-button>Meteum</b-button>
          </b-button-group>
        </section>
      </div>
      <div class="row row-labels mt-5">
        <label class="col-md-6">Dias</label>
        <label class="col-md-6">Exibição</label>
      </div>
      <div class="row mb-0">
        <section class="col-md-6">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">7</b-button>
            <b-button>15</b-button>
            <b-button>30</b-button>
            <b-button>60</b-button>
            <b-button>90</b-button>
            <b-dropdown>
              <b-dropdown-item>120</b-dropdown-item>
              <b-dropdown-item>Semestral</b-dropdown-item>
              <b-dropdown-item>Anual</b-dropdown-item>
            </b-dropdown>
          </b-button-group>

        </section>
        <section class="col-md-3">
          <b-button-group size="sm" class="w-full">
            <b-button class="btn btn-selected">Gráfico</b-button>
            <b-button>Tabela</b-button>
          </b-button-group>
        </section>
      </div>
      <div class="row row-labels mt-5">
        <label class="col-md-6">Região</label>
        <label class="col-md-6">Análise</label>
      </div>
      <div class="row mb-0">
        <section class="col-md-6">
          <div class="form-group">
            <v-select autocomplete :closeOnSelect="false" :options="[]" class="analitcs-dates">
            </v-select>
          </div>

        </section>
        <section class="col-md-6">

          <datepicker placeholder="Data" v-model="dateFilter" format="dd/MM/yyyy" :clear-button="true"
            :language="languages['ptBR']" id="datepicker-from"></datepicker>

        </section>
      </div>
      <div class="row mt-5 mb-5">
        <section class="col-md-2">
          <vs-button class="btn btn-xs btn-secondary rounded-pill" icon-pack="feather" icon="icon-search">Consultar</vs-button>
        </section>
        <section class="col-md-2 ml-5">
          <vs-button class="btn btn-secondary rounded-pill" color="primary" icon-pack="feather" icon="icon-share"></vs-button>
        </section>
        

      </div>
  </section>



    <div class="header-meteorology flex p-2 ">
      <section class="col-md-2"></section>
      <section class="col-md-2"></section>
      <section class="col-md-2">Precipitação</section>
      <section class="col-md-2">Temperatura</section>
      <section class="col-md-2">Vento</section>
      <section class="col-md-2">Radiação</section>
      <!-- <section class="col-md-2">6</section> -->

    </div>
    <div class="">
      <section class="">
        <div class="body-climate w-full">
          <div class="col-md-2">
            <div class="date">
              <span class="daybold">
                <span>Ter </span>
                <span class="year">2024</span>
              </span>
              <span class="date-week">05/03</span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="icon-climate">
              <span><img src="../../../assets/images/icons/sun.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Ensolarado"></span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="drop">
              <span><img src="../../../assets/images/icons/drop.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Umidade"></span>
              <div class="results">
                <span>1,0 <sup>mm</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="temperature">
              <span><img src="../../../assets/images/icons/temperature.svg" class="icon-variation"></span>
              <div class="results">
                <span>23 <sup>ºC</sup></span>
                <span>20 <sup>ºC</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wind">
              <span><img src="../../../assets/images/icons/wind.svg" class="icon-variation"></span>
              <div class="results">
                <span>2,97 <sup>m/s</sup></span>
                <span>135 <sup>ºSE</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="uv">
              <span><img src="../../../assets/images/icons/uv.svg" class="icon-variation"></span>
              <div class="results">
                <span>625 <sup>W/m2</sup></span>
              </div>
            </div>
          </div>
        </div>
        <div class="body-climate w-full">
          <div class="col-md-2">
            <div class="date">
              <span class="daybold">
                <span>Ter </span>
                <span class="year">2024</span>
              </span>
              <span class="date-week">05/03</span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="icon-climate">
              <span><img src="../../../assets/images/icons/sun.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Ensolarado"></span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="drop">
              <span><img src="../../../assets/images/icons/drop.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Umidade"></span>
              <div class="results">
                <span>1,0 <sup>mm</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="temperature">
              <span><img src="../../../assets/images/icons/temperature.svg" class="icon-variation"></span>
              <div class="results">
                <span>23 <sup>ºC</sup></span>
                <span>20 <sup>ºC</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wind">
              <span><img src="../../../assets/images/icons/wind.svg" class="icon-variation"></span>
              <div class="results">
                <span>2,97 <sup>m/s</sup></span>
                <span>135 <sup>ºSE</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="uv">
              <span><img src="../../../assets/images/icons/uv.svg" class="icon-variation"></span>
              <div class="results">
                <span>625 <sup>W/m2</sup></span>
              </div>
            </div>
          </div>
        </div>
        <div class="body-climate w-full">
          <div class="col-md-2">
            <div class="date">
              <span class="daybold">
                <span>Ter </span>
                <span class="year">2024</span>
              </span>
              <span class="date-week">05/03</span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="icon-climate">
              <span><img src="../../../assets/images/icons/sun.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Ensolarado"></span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="drop">
              <span><img src="../../../assets/images/icons/drop.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Umidade"></span>
              <div class="results">
                <span>1,0 <sup>mm</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="temperature">
              <span><img src="../../../assets/images/icons/temperature.svg" class="icon-variation"></span>
              <div class="results">
                <span>23 <sup>ºC</sup></span>
                <span>20 <sup>ºC</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wind">
              <span><img src="../../../assets/images/icons/wind.svg" class="icon-variation"></span>
              <div class="results">
                <span>2,97 <sup>m/s</sup></span>
                <span>135 <sup>ºSE</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="uv">
              <span><img src="../../../assets/images/icons/uv.svg" class="icon-variation"></span>
              <div class="results">
                <span>625 <sup>W/m2</sup></span>
              </div>
            </div>
          </div>
        </div>
        <div class="body-climate w-full">
          <div class="col-md-2">
            <div class="date">
              <span class="daybold">
                <span>Ter </span>
                <span class="year">2024</span>
              </span>
              <span class="date-week">05/03</span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="icon-climate">
              <span><img src="../../../assets/images/icons/sun.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Ensolarado"></span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="drop">
              <span><img src="../../../assets/images/icons/drop.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Umidade"></span>
              <div class="results">
                <span>1,0 <sup>mm</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="temperature">
              <span><img src="../../../assets/images/icons/temperature.svg" class="icon-variation"></span>
              <div class="results">
                <span>23 <sup>ºC</sup></span>
                <span>20 <sup>ºC</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wind">
              <span><img src="../../../assets/images/icons/wind.svg" class="icon-variation"></span>
              <div class="results">
                <span>2,97 <sup>m/s</sup></span>
                <span>135 <sup>ºSE</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="uv">
              <span><img src="../../../assets/images/icons/uv.svg" class="icon-variation"></span>
              <div class="results">
                <span>625 <sup>W/m2</sup></span>
              </div>
            </div>
          </div>
        </div>
        <div class="body-climate w-full">
          <div class="col-md-2">
            <div class="date">
              <span class="daybold">
                <span>Ter </span>
                <span class="year">2024</span>
              </span>
              <span class="date-week">05/03</span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="icon-climate">
              <span><img src="../../../assets/images/icons/sun.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Ensolarado"></span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="drop">
              <span><img src="../../../assets/images/icons/drop.svg" class="icon-variation" data-toggle="tooltip"
                  data-placement="top" title="Umidade"></span>
              <div class="results">
                <span>1,0 <sup>mm</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="temperature">
              <span><img src="../../../assets/images/icons/temperature.svg" class="icon-variation"></span>
              <div class="results">
                <span>23 <sup>ºC</sup></span>
                <span>20 <sup>ºC</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wind">
              <span><img src="../../../assets/images/icons/wind.svg" class="icon-variation"></span>
              <div class="results">
                <span>2,97 <sup>m/s</sup></span>
                <span>135 <sup>ºSE</sup></span>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="uv">
              <span><img src="../../../assets/images/icons/uv.svg" class="icon-variation"></span>
              <div class="results">
                <span>625 <sup>W/m2</sup></span>
              </div>
            </div>
          </div>
        </div>
        
    </section>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import FeatherIcon from '../../../@core/components/feather-icon/FeatherIcon.vue';
import vSelect from "vue-select";
import { BPopover } from 'bootstrap-vue';

export default {
  data() {
    return {
      dateFilter: "",
      languages: lang
    }
  },
  components: {
    Datepicker,
    FeatherIcon,
    vSelect,
    BPopover
  }
}



document.addEventListener('DOMContentLoaded', e => {
  $('#input-datalist').autocomplete()
}, false);
</script>

<style>
.alert-info {
  color: #0c5460;
  background-color: #e7fff3;
  border-color: #DDD;
}

.row.row-labels {
  margin-bottom: -5px;
}

.row.row-labels label {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.header-meteorology {
  background-color: #F2F2F2;
  border: 1px solid #DDD;
}

.date {
  text-align: center;
  display: inline;

  .daybold {
    font-weight: bold;
  }

  .year {
    font-weight: normal;
  }

  .date-week {
    font-size: 16px;
    font-weight: 800;
  }
}

button.vs-button-primary.vs-button-filled {
  /* background-color: #FFF !important;
  border: 1px solid #108d50 !important;
  display: flex;
  color: #108d50; */
}

.precipitation {
  text-align: center !important;
  display: inline-grid;
  padding-left: 5px;
}

.temperature {
  text-align: center;
  display: inline-grid;
}

.wind {
  text-align: center;
  display: inline-grid;
}

.radiation {
  text-align: center;
  display: inline-grid;
}

.body-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: #efefef; */
}

.body-content div {
  width: 100%;
  height: fit-content;
  text-align: center;
  color: #707070;
  /* justify-content: center; */
  align-items: center;
}

.body-climate {
  border: 1px solid #D6D6D6;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  margin-top: -1px;
}

span.city {
  color: #ABABAB;
  font-size: 10px;
  text-transform: Uppercase;
  position: absolute;
}

.body-content .date {
  display: grid;
}

.results span {
  text-align: left;
  padding-left: 5px;
}

.wind {
  display: flex;

  .results {
    display: grid;
  }
}

.temperature {
  display: flex;

  .results {
    display: grid;
  }
}

.drop {
  display: flex;

  .results {
    display: grid;
  }
}

.uv {
  display: flex;

  .results {
    display: grid;
  }
}

.icon-variation {
  position: relative;
  width: 35px;

}

.title-popover {
  font-size: 16px;
}

svg#report-type-info-popover-target {
  cursor: pointer;
  margin-top: 0px;
  position: absolute;
  margin-left: 2px;
}

.tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

sup {
  font-size: 10px;
}

.btn-group.btn-group-sm button {
  height: 30px !important;
  line-height: 0px !important;
}
.analitcs-dates{
  /* height: 30px; */
}
input#datepicker-from {
    height: 30px;
}
button.btn.btn-secondary {
    line-height: 0px;
}
.body-climate:hover{
  background-color: #efefef;
  cursor: pointer;
}
.daybold {
    font-weight: bold;
    display: flex;
}
</style>